// All equity sub-asset fund rules

import { IProduct } from '../../../../models/product'
import { ClassificationRulesEquityService } from '../../../classification-rules/classification-rules-equity.service'
import { FundRuleName } from '../fund-rule-name'
import { IFundRule } from '../ifund-rule'

export class EquityUSMarketRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_US
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isUSEquity(fund)
  }
}

export class EquityLargeRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_LARGE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isLargeCapEquity(fund)
  }
}

export class EquityINTRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_INTERNATIONAL
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isIntlEquity(fund)
  }
}

export class EquityDevRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_DEVELOPED
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isDevelopedEquity(fund)
  }
}

export class EquityEmergingRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_EMERGING
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isEmergingEquity(fund)
  }
}

export class EquityGlobalRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_GLOBAL
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isGlobalEquity(fund)
  }
}

export class EquityNonUSRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_NON_US
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isNonUSEquity(fund)
  }
}

export class EquityMidRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_MID
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isMidCapEquity(fund)
  }
}

export class EquitySmallRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_SMALL
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isSmallCapEquity(fund)
  }
}

export class EquityStyleIndexRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_INDEX
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isIndexEquity(fund)
  }
}

export class EquityStyleActiveRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_ACTIVE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isActiveEquity(fund)
  }
}

export class EquityBlendRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_BLEND
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isBlendEquity(fund)
  }
}

export class EquityGrowthRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_GROWTH
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isGrowthEquity(fund)
  }
}

export class EquityValueRule implements IFundRule {
  ruleName = FundRuleName.EQUITY_VALUE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesEquityService.isValueEquity(fund)
  }
}
